import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/admin/configuracion',
    name: 'configuracion.sitio',
    component: () => import('./views/ConfiguracionSitio.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'ajustes.read',
      breadcrumb: 'Configuración',
    },
  },
]

export default routes
